import { render, staticRenderFns } from "./PgaCertificationCreateAccessibility.vue?vue&type=template&id=af06982c&scoped=true&"
import script from "./PgaCertificationCreateAccessibility.vue?vue&type=script&lang=ts&"
export * from "./PgaCertificationCreateAccessibility.vue?vue&type=script&lang=ts&"
import style0 from "./PgaCertificationCreateAccessibility.vue?vue&type=style&index=0&id=af06982c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af06982c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af06982c')) {
      api.createRecord('af06982c', component.options)
    } else {
      api.reload('af06982c', component.options)
    }
    module.hot.accept("./PgaCertificationCreateAccessibility.vue?vue&type=template&id=af06982c&scoped=true&", function () {
      api.rerender('af06982c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Certifications/Accessibility/PgaCertificationCreateAccessibility.vue"
export default component.exports